import { EInvoiceAddressSchemeType } from '../enums/eInvoiceAddressSchemeType'

export type EInvoiceCountryConfig = {
  defaultPrivateScheme: EInvoiceAddressSchemeType
  defaultPublicScheme?: EInvoiceAddressSchemeType
  isFixedScheme: boolean
  isPublicEntitySupported: boolean
  isPublicEntityTooltipVisible: boolean
  isSchemeTypeSelectVisible: boolean
}

// When adding a new country, also update country-specific status events
// in InvoiceEventType and getTimelineStatusByInvoiceEventType.
export const eInvoiceCountryConfig: Record<string, EInvoiceCountryConfig> = {
  FR: {
    defaultPrivateScheme: EInvoiceAddressSchemeType.SIRENE,
    defaultPublicScheme: EInvoiceAddressSchemeType.SIRENE,
    isFixedScheme: true,
    isPublicEntitySupported: false,
    isPublicEntityTooltipVisible: false,
    isSchemeTypeSelectVisible: false,
  },
  DE: {
    defaultPrivateScheme: EInvoiceAddressSchemeType.VAT,
    defaultPublicScheme: EInvoiceAddressSchemeType.LWID,
    isFixedScheme: false,
    isPublicEntitySupported: true,
    isPublicEntityTooltipVisible: true,
    isSchemeTypeSelectVisible: true,
  },
}
